<template>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="商品分类" name="goodsCat">
            <swb-mercht-tpl-role-goods-cat v-if="activeName == 'goodsCat'" :roleId="roleId" :readOnly="readOnly"></swb-mercht-tpl-role-goods-cat>
        </el-tab-pane>
        <el-tab-pane label="服务分类" name="servcCat">
            <swb-mercht-tpl-role-servc-cat v-if="activeName == 'servcCat'" :roleId="roleId" :readOnly="readOnly"></swb-mercht-tpl-role-servc-cat>
        </el-tab-pane>
    </el-tabs>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import SwbMerchtTplRoleGoodsCat from './MerchtTplRoleGoodsCat';
    Vue.regist(SwbMerchtTplRoleGoodsCat);

    import SwbMerchtTplRoleServcCat from './MerchtTplRoleServcCat';
    Vue.regist(SwbMerchtTplRoleServcCat);

    export default {
        name: 'swb-mercht-biz-perm-scope-business-set',
        desc: '业务范围-业务设置',
        props: {
            roleId: { // 意义变化==》业务范围id
                type: Number,
                default: null
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                activeName: 'goodsCat'
            }
        },
        created: function () {
            //
        },
        methods: {
            handleClick: function (tab, event) {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtBizPermScopeBusinessSet.vue